import type { MeetingCardData } from '../types';

type MeetingRelationship = MeetingCardData['relationship'] | 'INVALIDATED';

const labels: Record<MeetingRelationship, string> = {
  HOST: 'Host',
  COHOST: 'Co-Host',
  EXPECTED: 'Dijemput',
  ATTENDED: 'Telah Hadir',
  INVALIDATED: 'Kehadiran Dibatalkan',
};

export default function MeetingRelationBadge({ relationship }: { relationship: MeetingRelationship }) {
  const emphasized = relationship === 'HOST' || relationship === 'COHOST';
  return <span className={`meeting-relation-pill relation-${relationship.toLowerCase()}`}>{emphasized ? <em>{labels[relationship]}</em> : labels[relationship]}</span>;
}
